module.exports = __webpack_public_path__ + "images/873422b325c17bdab767ef8c9a5463be.svg";